<template>
  <div>
    <p class="text-md font-semibold text-center mb-5">
      Select delivery location
    </p>
    <!-- <UDivider class="py-4"/> -->
    <p v-if="loading" class="text-center">Loading...</p>
    <p v-else-if="addresses.length === 0" class="text-center">
      No address found.
    </p>
    <div v-else class="max-h-96 overflow-auto">
      <div class="flex flex-col gap-4">
        <div v-for="(address, index) in addresses" :key="index">
          <div
            class="inline-flex gap-4 w-full p-3 border rounded-md"
            @click="selectReason(address.id)"
          >
            <div>
              <URadio label="" :value="address.id" :model-value="selected" />
            </div>
            <div class="flex flex-col gap-2">
              <div class="inline-flex w-full w-full flex justify-between">
                <p class="text-md font-semibold">{{ address.contact.name }}</p>
                <UBadge
                  variant="subtle"
                  size="xs"
                  color="blue"
                  :ui="{ rounded: 'rounded-sm' }"
                  >{{ address.label || "Home" }}</UBadge
                >
              </div>
              <div>
                <p class="text-sm">
                  {{ address.door }} {{ address.building }}
                  {{ address.locality }} {{ address.city }} -
                  {{ address.area_code }}, {{ address.state }}
                </p>
                <p class="text-sm">Phone: {{ address.contact.phone }}</p>
                <p class="text-sm">Email: {{ address.contact.email }}</p>
              </div>
              <div class="">
                <p
                  class="text-primary text-sm"
                  @click.stop="deleteAddress(address.id)"
                >
                  Delete
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- <ul>
                <li v-for="(address, index) in addresses" class="relative leading-8 text-sm border border-gray-200 rounded-md p-4" :key="index">
                    <label >
                        <input
                            type="checkbox"
                            :checked="selected === address.id"
                            @change="selectReason(address.id)"
                            class="form-checkbox text-primary absolute right-11 focus:ring-transparent"
                        />
                        <p class="text-md font-semibold">{{ address.contact.name }}</p>
                        <p class="text-sm ">{{ address.door }} {{ address.building }} {{ address.locality }} {{ address.city }} - {{ address.area_code }}, {{ address.state }}</p>
                        <p class="text-sm">Phone: {{ address.contact.phone }}</p>
                        <p class="text-sm">Email: {{ address.contact.email }}</p>
                    </label>
                </li>
            </ul> -->
    </div>
    <UDivider class="py-5" />
    <div class="flex flex-col justify-center items-center">
      <p v-if="lenghtError" class="text-xs pb-5 text-red-500">
        You cannot save more than 5 address, Please delete atleast 1 address to
        add new
      </p>
      <!-- <UButton
        size="md"
        label="Add New Address"
        class="w-full"
        @click="addNewAddress"
      /> -->
      <button class="w-full addressButton" size="md" @click="addNewAddress">
        Add New Address
      </button>
    </div>
  </div>
</template>
<script setup>
import { V3PopupComponent, V3ModalComponent } from "#components";

const selected = ref(null);
const addresses = ref([]);
const emit = defineEmits(["close", "success"]);
const isLoading = ref(false);
const lenghtError = ref(false);
const loading = ref(false);
const location = useLocation();
const { isMobile } = useDevice();
const slideover = useSlideover();
const modal = useModal();
const checkout = useCheckout();
const cart = useCart();

const selectReason = (id) => {
  selected.value = selected.value === id ? null : id;
  confirm();
};

const getAddresses = async () => {
  try {
    loading.value = true;
    lenghtError.value = false;
    const response = await useAPIHandler("get", "/account/addresses", {
      auth: true,
    });
    addresses.value = response.data;
  } catch (err) {
    console.log(err);
  } finally {
    loading.value = false;
  }
};

onBeforeMount(async () => {
  getAddresses();
});

const addNewAddress = () => {
  if (addresses.value.length >= 5) {
    lenghtError.value = true;
    return;
  } else {
    const tmp = isMobile ? slideover : modal;
    const cmp = isMobile ? V3PopupComponent : V3ModalComponent;
    tmp.open(cmp, {
      // component: 'addressPicker',
      component: "location",
      onSuccess: async () => {
        const loc = useLocation();
        const tmp1 = isMobile ? slideover : modal;
        tmp1.open(cmp, {
          component: "addressPicker",
          onSuccess: async (address) => {
            const data = {
              name: address.contact.name,
              phone: address.contact.phone,
              email: address.contact.email,
              address_line1: address.door,
              address_line2: address.building,
              address_line3: address.locality,
              area_code: address.area_code,
              city: address.city,
              state: address.state,
              gps: address.gps,
            };
            await location.setAddress(data);
            await location.setCityCode(data.city);
            await Promise.all([ checkout.setDeliveryAddress(data), checkout.setSelectedAddress(data) ]);
            // setTimeout(() => {
            //   tmp.close;
            // }, 500);
            tmp1.close();
            setTimeout(
            async () => {
              await navigateTo({ path: "/cart", query: { addr: 1 } });
              cart.fetchQuote(),
            200
          });
          },
          onClose: tmp1.close,
        });
      },
      onClose: tmp.close,
    });
  }
};

const deleteAddress = async (addressId) => {
  try {
    await useAPIHandler("delete", `/account/addresses/${addressId}`, {
      auth: true,
    });
    lenghtError.value = false;
    await getAddresses();
  } catch (err) {
    console.log(err);
  }
};

const confirm = async () => {
  if (selected.value === null) {
    return;
  }
  isLoading.value = true;
  const address = addresses.value.find((k) => k.id === selected.value);
  const data = {
    name: address.contact.name,
    phone: address.contact.phone,
    email: address.contact.email,
    address_line1: address.door,
    address_line2: address.building,
    address_line3: address.locality,
    area_code: address.area_code,
    city: address.city,
    state: address.state,
    gps: address.gps,
  };
  const checkout = useCheckout();
  const location = useLocation();
  const isSame =
    Number(location.area_code) === Number(data.area_code) &&
    location.city.name.toLowerCase() === data.city.toLowerCase() &&
    location.state.name.toLowerCase() === data.state.toLowerCase();
  if (isSame) {
    await Promise.all([
                  checkout.setDeliveryAddress(data),
                  checkout.setSelectedAddress(data)
                ]);
    await location.setAddress(data);
    emit("success");
  } else {
    // checkout.setSelectedAddress(data);
    // checkout.setDeliveryAddress(data);
    if (isMobile) {
      slideover.open(V3PopupComponent, {
        component: "addresschange",
        onSuccess: async () => {
          await location.setAddress(data);
          await location.setCityCode(data.city);
          await Promise.all([
                  checkout.setDeliveryAddress(data),
                  checkout.setSelectedAddress(data)
                ]);
          slideover.close();
          setTimeout(
            () => {
              navigateTo({ path: "/cart", query: { addr: 0 } });
              cart.fetchQuote(),
            100
          }
          );
        },
        onClose: slideover.close,
      });
    } else {
      modal.open(V3ModalComponent, {
        component: "addresschange",
        onSuccess: async () => {
          await location.setAddress(data);
          await location.setCityCode(data.city);
          
          await Promise.all([
                checkout.setDeliveryAddress(data),
                  checkout.setSelectedAddress(data)
                ]);
          modal.close();
          setTimeout(
            () => {
              navigateTo({ path: "/cart", query: { addr: 0 } });
              cart.fetchQuote(),
            100
          }
          );
        },
        onClose: modal.close,
      });
    }
  }
};
</script>
